module.exports = __webpack_public_path__ + "img/Phone Icon - white.df531971.svg";